import { EducatorActionTypes } from '../educator.action-types'

const initialStates = {
    educators: [],
    metadataEducators: {},
    eudcatorQueries: {},
    parentStates: [],
    parentCities: [],
    studentStates: [],
    studentCities: [],
    dynamicCities: [],
    educatorDetail: {},
    educatorLoadingModal: false,
}

const EducatorInfoReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case EducatorActionTypes.GET_PARENT_STATES:
            return {
                ...state,
                parentStates: action.payload,
            }
        case EducatorActionTypes.GET_PARENT_CITIES:
            return {
                ...state,
                parentCities: action.payload,
            }
        case EducatorActionTypes.GET_STUDENT_STATES:
            return {
                ...state,
                studentStates: action.payload,
            }
        case EducatorActionTypes.GET_STUDENT_CITIES:
            return {
                ...state,
                studentCities: action.payload,
            }
        case EducatorActionTypes.GET_DYNAMIC_CITY:
            return {
                ...state,
                dynamicCities: action.payload,
            }
        case EducatorActionTypes.GET_EDUCATOR_INFO:
            return {
                ...state,
                educators: action.payload,
            }
        case EducatorActionTypes.GET_EDUCATOR_INFO_METADATA:
            return {
                ...state,
                metadataEducators: action.payload,
            }
        case EducatorActionTypes.GET_EDUCATOR_INFO_DETAIL:
            return {
                ...state,
                educatorDetail: action.payload,
            }
        case EducatorActionTypes.SET_EDUCATOR_QUERIES:
            return {
                ...state,
                eudcatorQueries: action.payload,
            }
        case EducatorActionTypes.SET_EDUCATOR_LOADING_MODAL:
            return {
                ...state,
                educatorLoadingModal: action.payload,
            }
        default:
            return { ...state }
    }
}

export default EducatorInfoReducer
